<app-content-shell [resizablePanel]="true">

  <app-header mainHeader />

  <app-panel-header panelHeader [title]="'Agents'">
    <button action mat-icon-button *allowedRole="'admin'" (click)="addNewItem()" matTooltip="Add agent"><mat-icon>add</mat-icon></button>
  </app-panel-header>

  <div panelSearch>
    <app-panel-search [(query)]="searchQuery" placeholder="Search agents..." />
  </div>

  <div panelContent>
    @for (bot of filteredBots; track bot._id) {
      <app-list-item [selected]="selectedBot?._id === bot._id" (click)="selectBot(bot)">
        <span itemTitle>{{ bot.title }}</span>
        <ng-container itemSuffix>
          <app-bot-status-badge [botType]="bot.botType" [botStatus]="bot.bot_status" />
        </ng-container>
      </app-list-item>
    }
    @if (filteredBots.length === 0 && searchQuery) {
      <p class="empty-indicator">No agents found</p>
    }
  </div>

  <div mainContent class="bots-main-content full-height-content">
    @if (!selectedBot) {
      <app-empty-state
        icon="smart_toy"
        title="Select an agent"
        subtitle="Choose an agent from the list to start a conversation."
      />
    } @else {
      <app-agent-conversation [talkingWith]="selectedBot!">
        <div header>
          <app-talking-avatar [agent]="selectedBot" />
        </div>
      </app-agent-conversation>
    }
  </div>

</app-content-shell>
